import { render, staticRenderFns } from "./dgsaFileUpload.vue?vue&type=template&id=b84fb1a6&scoped=true"
import script from "./dgsaFileUpload.vue?vue&type=script&lang=js"
export * from "./dgsaFileUpload.vue?vue&type=script&lang=js"
import style0 from "./dgsaFileUpload.vue?vue&type=style&index=0&id=b84fb1a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84fb1a6",
  null
  
)

export default component.exports